/**
 * Types of application idle:
 * 0: NONE, the application is not in idle
 * 1: STANDARD, the application is in idle by useIdle in ScreenSaver Component
 * 2: FORCED, force the application idle without useIdle (ex: button in homepage to show screen saver)
 * @type {{FORCED: number, NONE: number, STANDARD: number}}
 */
export const IDLE_TYPES = {
  NONE: 0,
  STANDARD: 1,
  FORCED: 2,
  FORCED_NONE: 3
};
